export { default } from './NumbersAvailableTable.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersAvailableTable/index.js